import { Box, Button, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography, useTheme } from "@mui/material"
import { useEffect, useState } from "react"
import { usePageTitle } from "../../../hooks"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { ModalCEP } from "../modal/cep"
import SerasaImg from "../../../assets/img/serasa-logo.png"
import { TarjaSecurity } from "./tarja"
import { sendToShow } from "../../../utils"
import { ModalNotAllowed } from "./modalNotAllowed"

export const QuestionsLP = () => {
    usePageTitle("Enquete")
    const { palette } = useTheme()
    const navigate = useNavigate()
    const { state } = useLocation()

    const [question, setQuestion] = useState(1)
    const [value, setValue] = useState<boolean | null>(null)

    const [openModalCEP, setOpenModalCEP] = useState(false)
    const [openModalNotAllowed, setOpenModalNotAllowed] = useState(false)
    const [hasFailed, setHasFailed] = useState(false)

    const questions: { title: string | JSX.Element, description: string | JSX.Element, options: { value: boolean, label: JSX.Element }[], selectLabel: JSX.Element }[] = [
        {
            title: <Grid
                display={"block"}
                gap={".5rem"}
                alignSelf={"center"}
            >
                Verificação do CPF na <img src={SerasaImg} alt="logo da serasa" width={"100px"} style={{ marginBottom: "-10px" }} />
            </Grid>,
            description:
                <Grid>
                    <Typography
                        textAlign={"justify"}
                        padding={0}
                    >
                        Para que possamos dar continuidade nos responda, como está seu <strong>CPF</strong> junto a SERASA?
                    </Typography>
                    <Link
                        to={"https://www.serasa.com.br/area-cliente/meu-cpf/pendencias"}
                        style={{
                            fontStyle: "italic",
                            color: palette.primary.main,
                            textAlign: "start",
                            fontSize: "1.4rem",
                            textDecoration: "none"
                        }}
                        target="_blank"
                    >(Opcional) <span style={{ textDecoration: "underline" }}>Para saber a situação do seu CPF, clique aqui e consulte gratuitamente</span></Link>
                </Grid >,
            options: [
                {
                    label: <>Estou <strong><u>com dívida</u></strong> em meu <strong>CPF</strong> na <strong>SERASA</strong></>,
                    value: false
                },
                {
                    label:
                        <Typography>Meu <strong>CPF</strong> está <strong><u>sem dívida</u></strong> na <strong>SERASA</strong>.<br />
                            <Typography component="span" sx={{ color: "GrayText", fontStyle: "italic", ml: -1 }}>
                                Eu autorizo que a empresa GYROO S.A. consulte meu CPF e analise meus dados, documentos e fotos.
                            </Typography>
                        </Typography>,
                    value: true
                }
            ],
            selectLabel: <Typography p={0}>Por favor, selecione a atual situação do seu <strong>CPF</strong>:</Typography>
        },
        {
            title: <Grid
                display={"block"}
                gap={".5rem"}
                alignSelf={"center"}
            >
                Verificação do <u>CNPJ</u> na <img src={SerasaImg} alt="logo da serasa" width={"100px"} style={{ marginBottom: "-10px" }} />
            </Grid>,
            description: <Grid>
                <Typography
                    textAlign={"justify"}
                    padding={0}
                >
                    Agora nos responda como está a situação do seu <strong>CNPJ</strong> junto a SERASA?
                </Typography>
                <Link
                    to={"https://www.serasaempreendedor.com.br/login?adobe_mc=MCMID%3D66549402845421543914330329769193561509%7CMCORGID%3D2436FCE859C0D3FA0A495C84%2540AdobeOrg%7CTS%3D1749672060&_gl=1*hbutkj*_gcl_au*MjEzMzc3NjYxOS4xNzQ5NjcyMDYx*_ga*MTQxNTEyNDk3My4xNzQ5NjcyMDYx*_ga_0CR6WR71VQ*czE3NDk2NzIwNjAkbzEkZzAkdDE3NDk2NzIwNjAkajYwJGwwJGgzMjk5MzMzMDQ"}
                    style={{
                        fontStyle: "italic",
                        color: palette.primary.main,
                        textAlign: "start",
                        fontSize: "1.4rem",
                        textDecoration: "none"
                    }}
                    target="_blank"
                >(Opcional) <span style={{ textDecoration: "underline" }}>Para saber a situação do seu CNPJ, clique aqui e consulte gratuitamente</span></Link>
            </Grid >,
            options: [
                {
                    label: <>Estou <strong><u>com dívida</u></strong> em meu <strong>CNPJ</strong> na <strong>SERASA</strong></>,
                    value: false
                },
                {
                    label: <Typography>Meu <strong>CNPJ</strong> está <strong><u>sem dívida</u></strong> na <strong>SERASA</strong>.<br />
                        <Typography component="span" sx={{ color: "GrayText", fontStyle: "italic", ml: -1 }}>
                            Eu autorizo que a empresa GYROO S.A., consulte meu CNPJ e analise os dados e documentos da minha empresa.
                        </Typography>
                    </Typography>,
                    value: true
                }
            ],
            selectLabel: <Typography p={0}>Por favor, selecione a atual situação do seu <strong>CNPJ</strong>:</Typography>

        },
    ]

    useEffect(() => {
        if (!state?.verified) navigate(-1)
        if (state?.checkCep) setOpenModalCEP(true)
    }, [])


    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Box
                id={"progress"}
                alignSelf={"center"}
                width={"100%"}
                height={"1.3rem"}
                borderRadius={"50px"}
                sx={{
                    position: "relative",
                    backgroundColor: "rgba(0,0,0,.1)",
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: `${((question * 100) / questions.length) - 5}%`,
                        transition: "width .5s ease-out",
                        background: "linear-gradient(90deg, #1D22E6 0%, #01E7FE 100%)",
                        borderRadius: "50px",
                    }}
                />
            </Box>

            <Typography p={0} fontWeight={700} fontSize={"2rem"}>{questions[question - 1].title}</Typography>

            <Typography p={0} fontSize={"1.6rem"} mt={"2rem"} sx={{ opacity: openModalCEP ? 0 : 1 }}>{questions[question - 1].description}</Typography>

            <Typography p={0} m={"2rem 0"} fontWeight={400} fontSize={"1.6rem"} sx={{ opacity: openModalCEP ? 0 : 1 }}>{questions[question - 1].selectLabel}</Typography>

            <FormControl sx={{
                width: "100%",
                height: "auto",
                borderRadius: 0
            }}>
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={value}
                    onChange={(e) => setValue(e.target.value === "true")}
                    sx={{
                        "& .MuiFormControlLabel-root": {
                            width: "100%",
                            height: "auto"
                        },
                    }}
                >
                    {questions[question - 1].options.map(({ label, value }, index) => <FormControlLabel value={value} control={<Radio />} label={label} sx={{
                        ...(index > 0 && {
                            mt: 6
                        })
                    }} />
                    )}
                </RadioGroup>
            </FormControl>

            {value &&
                <Typography color="warning" mt={2} textAlign={"center"} fontStyle={"italic"}>
                    Observação: Certifique-se de deixar seu {question === 1 ? "CPF" : "CNPJ"} desbloqueado pra consulta pública na Serasa.
                </Typography>}

            <Button
                variant="contained"
                color="primary"
                disabled={value === null}
                sx={{ width: "100%", opacity: openModalCEP ? 0 : 1, fontWeight: "bold", mt: 4, mb: 2 }}
                onClick={() => {
                    if (value) {
                        if (question === questions.length) {
                            navigate("/cadastro" + window.location.search, {
                                state: {
                                    verified: true,
                                    hasFailed: hasFailed
                                }
                            })
                        } else {
                            sendToShow("progress", "end")
                            setTimeout(() => {
                                setQuestion(question + 1)
                                setValue(null)
                            }, 200);
                        }
                    } else {
                        if (question === questions.length) {
                            navigate("/cadastro" + window.location.search, {
                                state: {
                                    verified: true,
                                    hasFailed: true
                                }
                            })
                        } else {
                            setHasFailed(true)
                            sendToShow("progress", "end")
                            setTimeout(() => {
                                setQuestion(question + 1)
                                setValue(null)
                            }, 200);
                        }
                        // setOpenModalNotAllowed(true)
                    }
                }}
            >
                CONFIRMAR
            </Button>

            <TarjaSecurity />

            <ModalCEP
                open={openModalCEP}
                onClose={() => setOpenModalCEP(false)}
                onConfirm={(allowed) => {
                    if (allowed) {
                        navigate("#", {
                            state: {
                                checkCep: false,
                                verified: true
                            }
                        })
                        window.location.reload()
                    } else {
                        navigate("/", {
                            state: {
                                notAllowed: true
                            }
                        })
                    }
                }}
                verify />

            <ModalNotAllowed
                open={openModalNotAllowed}
                onClose={() => {
                    setOpenModalNotAllowed(false)
                    navigate("/" + window.location.search, {
                        state: {
                            verified: true,
                        }
                    })
                }}
            />
        </div>
    )
}